module.exports = __webpack_public_path__ + "static/img/thumbnail_nofile_news.391bfb48.svg";